'use client';

import { useDummyMode } from '@/hooks/useDummyMode';

/**
 * Dummy Mode Indicator Component
 * 
 * Displays a visual indicator in the top right corner when dummy mode is enabled.
 * Shows a yellow background box with orange border and "test mode" text.
 */
export default function DummyModeIndicator() {
  const { isDummyMode } = useDummyMode();

  if (!isDummyMode) {
    return null;
  }

  return (
    <div data-component-id="src/components/common/DummyModeIndicator.tsx:19:4" data-component-path="src/components/common/DummyModeIndicator.tsx" data-component-line="19" data-component-end-line="25" data-component-file="DummyModeIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20top-4%20right-4%20z-50%20pointer-events-none%22%7D" className="fixed top-4 right-4 z-50 pointer-events-none">
      <div data-component-id="src/components/common/DummyModeIndicator.tsx:20:6" data-component-path="src/components/common/DummyModeIndicator.tsx" data-component-line="20" data-component-end-line="24" data-component-file="DummyModeIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-yellow-400%20border-2%20border-orange-500%20rounded-lg%20px-4%20py-2%20shadow-lg%22%7D" className="bg-yellow-400 border-2 border-orange-500 rounded-lg px-4 py-2 shadow-lg">
        <span data-component-id="src/components/common/DummyModeIndicator.tsx:21:8" data-component-path="src/components/common/DummyModeIndicator.tsx" data-component-line="21" data-component-end-line="23" data-component-file="DummyModeIndicator.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-orange-600%20font-semibold%20text-sm%20uppercase%20tracking-wide%22%2C%22textContent%22%3A%22Test%20Mode%22%7D" className="text-orange-600 font-semibold text-sm uppercase tracking-wide">
          Test Mode
        </span>
      </div>
    </div>
  );
}
